import { createSelector } from 'reselect';
import { selectMembershipApiHost } from 'globalSelectors'
import { selectBody } from 'components/Body/store/selectors'

export const selectBodyDatEntryApp = (store) => selectBody(store).dataEntry
export const selectBodyDataEntryContact = (store) => selectBodyDatEntryApp(store)?.contactResults || {}

const fetchRequest = (store, count, page, filter, sort, url, refresh) => ({ count, page, filter, sort, url, status: store.status, refresh })

export const selectContactUrl = createSelector(
    [selectMembershipApiHost],
    host => `${host}/Contact`
)

export const selectContactCurrentPage = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.currentPage || 1
)

export const selectContactTotalPages = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.totalPages || 0
)

export const selectContactRows = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.row || 10
)

export const selectContactFirst = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.first || 0
)

export const selectContactFilter = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.filter || null
)

export const selectContactSort = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.sort || null
)

export const selectContactRefresh = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.refresh || false
)

export const selectContactFetchRequest = createSelector(
    [selectBodyDataEntryContact, selectContactRows, selectContactCurrentPage, selectContactFilter, selectContactSort, selectContactUrl, selectContactRefresh],
    fetchRequest
)

export const selectContactFetchResults = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.results || null
)

export const selectContactFetchStatus = createSelector(
    [selectBodyDataEntryContact],
    (mem) => mem?.status || { status: 'idle' }
)

// Contact Works Selectors - now support multiple contacts by contactId
export const selectContactWorksByContactId = (contactId) => createSelector(
    [selectBodyDataEntryContact],
    (contact) => contact?.works?.byContactId?.[contactId] || {
        status: 'idle',
        results: { total: 0, results: [] },
        currentPage: 1,
        totalPages: 0,
        row: 10,
        first: 0,
        sort: null,
        filter: null
    }
)

export const selectContactWorksCurrentPage = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.currentPage || 1
)

export const selectContactWorksTotalPages = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.totalPages || 0
)

export const selectContactWorksRows = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.row || 10
)

export const selectContactWorksFirst = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.first || 0
)

export const selectContactWorksFilter = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.filter || null
)

export const selectContactWorksSort = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.sort || null
)

export const selectContactWorksRefresh = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.refresh || false
)

export const selectContactWorksFetchResults = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.results || { total: 0, results: [] }
)

export const selectContactWorksFetchStatus = (contactId) => createSelector(
    [selectContactWorksByContactId(contactId)],
    (contactWorks) => contactWorks?.status || { status: 'idle' }
)

export const selectContactWorksUrl = (store, contactId) => createSelector(
    [selectMembershipApiHost],
    host => `${host}/Contact/${contactId}/Works`
)(store)

// Helper function to build the request object
const buildWorksRequest = (contactWorks, contactId, url) => ({ 
    currentContactId: contactId,
    count: contactWorks?.row || 10, 
    page: contactWorks?.currentPage || 1, 
    filter: contactWorks?.filter || null, 
    sort: contactWorks?.sort || null, 
    url, 
    status: contactWorks?.status || { status: 'idle' }
})

// Main selector for works request
export const selectContactWorksRequest = (contactId) => createSelector(
    [
        selectContactWorksByContactId(contactId),
        (store) => selectContactWorksUrl(store, contactId)
    ],
    (contactWorks, url) => buildWorksRequest(contactWorks, contactId, url)
)






